import script from "./CartPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./CartPayment.vue?vue&type=script&setup=true&lang=js"

import "./CartPayment.vue?vue&type=style&index=0&id=6782b3f4&lang=scss"

const __exports__ = script;

export default __exports__